import { Heading } from '@dtpk-cc/components';
import { FormProvider } from 'react-hook-form';
import { CustomerSearchForm } from './components/CustomerSearchForm';
import { useCustomerSearch } from './hooks/useCustomerSearch';
import { useDisplayErrorForCustomerSearch } from 'hooks/useDisplayErrorForCustomerSearch';

export const CustomerSearchPage = () => {
    const { form, search, skipPath, goBackPath, error } = useCustomerSearch();
    const displayError = useDisplayErrorForCustomerSearch(error, skipPath);

    return (
        <div data-test-section="customer-search">
            <Heading tag="h1" variants={Heading.Variant.secondary}>
                Bitte loggen Sie sich ein
            </Heading>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <FormProvider {...form}>
                <CustomerSearchForm submit={search} skipPath={skipPath} goBackPath={goBackPath} />
            </FormProvider>
            {displayError}
        </div>
    );
};
